export const DELIVERY_MODE = {
  HOME: "home",
  BIN: "bin",
};

export const DELIVERY_MODE_LIST = [
  { value: DELIVERY_MODE.HOME, labelKey: "companies.form.projectinfo.deliveryMode.home.title" },
  { value: DELIVERY_MODE.BIN, labelKey: "companies.form.projectinfo.deliveryMode.bin.title" },
];

export default DELIVERY_MODE;
